import React, { useState } from "react";
import classes from "./ShifuForm.module.css";
import submit_btn from "../assets/submit_btn.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { server_url } from "../index";

const ShifuForm = ({ onClose }) => {
    const [selectedOption, setSelectedOption] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    work_email: "",
    company: "",
    role: "",
    goals: "",
  });

  const options = [
    "Request a Demo",
    "Start a Pilot Program",
    "General Inquiry",
    "Schedule a Briefing",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    const name = formData.name.trim();
    const email = formData.work_email.trim().toLowerCase();
    const company = formData.company.trim();

    if (!name || !email || !company) {
      toast.error("Please fill all required fields");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }

  const blockedDomains = [
  // Global Free Email Providers
  "gmail.com",
  "googlemail.com",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "msn.com",
  "yahoo.com",
  "ymail.com",
  "aol.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "proton.me",
  "protonmail.com",
  "pm.me",
  "zoho.com",
  "gmx.com",
  "gmx.net",
  "mail.com",
  "yandex.com",
  "yandex.ru",
  "tutanota.com",

  
  "startmail.com",
  "mailbox.org",
  "posteo.de",

  // India Specific
  "rediffmail.com",
  "rediff.com",
  "indiatimes.com",

  // International Providers
  "web.de",
  "libero.it",
  "laposte.net",
  "orange.fr",
  "t-online.de",
  "163.com",
  "126.com",
  "qq.com",
  "sina.com"
];

    const domain = email.split("@")[1];

    if (blockedDomains.includes(domain)) {
      toast.error("Please use your official email address");
      return;
    }

    if (!selectedOption) {
      toast.error("Please select what you are looking for");
      return;
    }

    try {
      const response = await fetch(`${server_url}/api/shifu`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          work_email: email,
          company_name: company,
          role: formData.role?.trim() || "",
          goals: formData.goals?.trim() || "",
          looking_for: selectedOption.trim(),
        }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        toast.error(data.error || "Something went wrong");
        return;
      }

      toast.success("Request submitted successfully");

    // Reset form
    setFormData({
      name: "",
      work_email: "",
      company: "",
      role: "",
      goals: "",
    });

    setSelectedOption("");

    // ✅ Auto close after 1.5 sec
    setTimeout(() => {
      if (onClose) {
        onClose();
      }
    }, 1500);

  } catch (error) {
    toast.error("Backend not reachable");
  }
};
  return (
    <div className={classes.formWrapper}>
      <div className={classes.formCard}>
        <h2 className={classes.formtitle}>Let’s Get Started</h2>
        <p className={classes.formsubtitle}>
          Tell us about yourself and what you’re looking to achieve.
        </p>

        <div className={classes.row}>
          <div className={classes.inputgroup}>
            <label className={classes.labels}>Name*</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="e.g., Prem Kumar"
              className={classes.input}
            />
          </div>

          <div className={classes.inputgroup}>
            <label className={classes.labels}>Work Email*</label>
            <input
              type="email"
              name="work_email"
              value={formData.work_email}
              onChange={handleChange}
              placeholder="e.g., prem@gmail.com"
              className={classes.input}
            />
          </div>
        </div>

        <div className={classes.row}>
          <div className={classes.inputgroup}>
            <label className={classes.labels}>Company*</label>
            <input
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              placeholder="e.g., Acme Corporation"
              className={classes.input}
            />
          </div>

          <div className={classes.inputgroup}>
            <label className={classes.labels}>Role</label>
            <input
              type="text"
              name="role"
              value={formData.role}
              onChange={handleChange}
              placeholder="e.g., Head of L&D"
              className={classes.input}
            />
          </div>
        </div>

        <div className={classes.optionSection}>
          <label className={classes.optionlabel}>
            What are you looking for?*
          </label>
          <div className={classes.optionGrid}>
            {options.map((option, index) => (
              <button
                key={index}
                type="button"
                className={`${classes.optionBtn} ${
                  selectedOption === option ? classes.active : ""
                }`}
                onClick={() => setSelectedOption(option)}
              >
                {option}
              </button>
            ))}
          </div>
        </div>

        <div className={classes.textareaGroup}>
          <label className={classes.labels}>Tell us about your goals</label>
          <textarea
            name="goals"
            value={formData.goals}
            onChange={handleChange}
            placeholder="What challenges are you facing?"
            className={classes.textareaclass}
          ></textarea>
        </div>

        <button onClick={handleSubmit} className={classes.submitBtn}>
          SUBMIT REQUEST <img src={submit_btn} alt="submit" />
        </button>

        <ToastContainer position="top-right" autoClose={3000} theme="dark" />
      </div>
    </div>
  );
};

export default ShifuForm;
